import React, { memo } from 'react';
import { SortableDroppableList, SortableListOverlay } from './SortableList';
import { areEqualWithIndexPath } from './helpers';
import { SortableCard, SortableCard2 } from './Card';

export const LaneContent = memo(function LaneContent({
	lane,
	parentId,
	indexPath = [],
	isOverlay,
	onOpenAvailableWidgets,
	defaultPreview,
	destinationLane,
	onForceMove,
	onSelectWidget,
	widgetSettings,
}) {
	const ListElement = isOverlay ? SortableListOverlay : SortableDroppableList;
	const ctx = {
		parentId,
		indexPath,
		data: lane,
	};

	const className = defaultPreview
		? ''
		: 'grid grid-cols-1 md:grid-cols-4 gap-6 flex-1 ';

	return (
		<>
			<ListElement
				content={lane}
				accepts="item"
				ctx={ctx}
				className={className}
				// className="gap-6 flex flex-col w-full"
			>
				{lane?.children?.length
					? lane?.children
							?.filter((item) => item)
							.map((item, i) => {
								return (
									<SortableCard
										key={item.id}
										isOverlay={!!isOverlay}
										item={item}
										itemIndex={i}
										laneId={lane.id}
										laneIndexPath={indexPath}
										defaultPreview={defaultPreview}
										destinationLane={destinationLane}
										onForceMove={onForceMove}
										widgetSettings={widgetSettings}
									/>
								);
							})
					: null}
			</ListElement>
		</>
	);
}, areEqualWithIndexPath);

export const LaneContent2 = memo(function LaneContent({
	lane,
	parentId,
	indexPath = [],
	isOverlay,
	onOpenAvailableWidgets,
}) {
	const ListElement = isOverlay ? SortableListOverlay : SortableDroppableList;
	const ctx = {
		parentId,
		indexPath,
		data: lane,
	};

	return (
		<>
			<ListElement
				content={lane}
				accepts="item"
				ctx={ctx}
				// className="grid grid-cols-4 gap-6 flex-1 "
				className="gap-6 flex flex-col w-full"
			>
				{lane?.children?.length
					? lane?.children?.map((item, i) => {
							return (
								<SortableCard2
									key={item.id}
									isOverlay={!!isOverlay}
									item={item}
									itemIndex={i}
									laneId={lane.id}
									laneIndexPath={indexPath}
								/>
							);
						})
					: null}
			</ListElement>
		</>
	);
}, areEqualWithIndexPath);

export const SortableLane = memo(function SortableLane({
	lane,
	laneIndex,
	parentId,
	onOpenAvailableWidgets,
	defaultPreview,
	destinationLane,
	onForceMove,
	widgetSettings,
}) {
	const ctx = {
		parentId,
		indexPath: [laneIndex],
		data: lane,
	};

	return (
		<LaneContent
			parentId={parentId}
			indexPath={ctx.indexPath}
			lane={lane}
			onOpenAvailableWidgets={onOpenAvailableWidgets}
			defaultPreview={defaultPreview}
			destinationLane={destinationLane}
			onForceMove={onForceMove}
			widgetSettings={widgetSettings}
		/>
	);
});

export const SortableLane2 = memo(function SortableLane({
	lane,
	laneIndex,
	parentId,
	onOpenAvailableWidgets,
}) {
	const ctx = {
		parentId,
		indexPath: [laneIndex],
		data: lane,
	};

	return (
		<LaneContent2
			parentId={parentId}
			indexPath={ctx.indexPath}
			lane={lane}
			onOpenAvailableWidgets={onOpenAvailableWidgets}
		/>
	);
});
